import { useQuery, UseQueryOptions } from 'react-query';

import { addressesApi } from 'src/Services/API';
import { AutocompleteV2ResponseDto } from 'src/Services/API/generated';

const useFetchUser = (
  inputValue?: string,
  options?: UseQueryOptions<
    AutocompleteV2ResponseDto,
    unknown,
    AutocompleteV2ResponseDto,
    (string | undefined)[]
  >
) => {
  return useQuery({
    queryKey: ['get-address-autocomplete-suggestions', inputValue],
    queryFn: async () => {
      const response = await addressesApi.addressesControllerGetAutocompleteSuggestions(
        inputValue!
      );
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: !!inputValue && inputValue.trim().length >= 3,
    keepPreviousData: true,
    ...options,
  });
};

export default useFetchUser;
